import React, { useState } from 'react';
import './css/index.scss';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import MyButton from '../../components/MyButton';
import IconButton from '../../components/IconButton';
import CancelEditingIcon from '../../assets/formIcons/cancelEditing.svg';
import SelectButton from '../../components/SelectButton';
import SelectOperationType from './components/SelectOperationType';
import sendRequest from '../../helpers/sendRequest';
import Api from '../../Api';
import MyModal from '../../components/MyModal';

const tempComponentStates = {
  operationType: 'operationType',
};

const OPERATION_TYPE_LABELS = {
  parsingEventsFromKontramarka: 'Парсинг Kontramarka',
  parsingEventsFromFienta: 'Парсинг Fienta',
  parsingEventsFromEventim: 'Парсинг Eventim',
  sendNewOrganizationsNotifications: 'Отправка уведомлений о новых организациях',
  sendNewEventsNotifications: 'Отправка уведомлений о новых мероприятиях',
  sendNewOnlineOrganizationsNotifications: 'Отправка уведомлений о новых онлайн организациях',
};

function NewOperation() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalText, setModalText] = useState('');
  const [modalState, setModalState] = useState('');
  const [selectedType, setSelectedType] = useState(null);
  const [tempComponentState, setTempComponentState] = useState(null);

  const onCancelClick = () => {
    navigate('/operations/view');
  };

  const onCloseModal = () => {
    if (modalState === 'error') {
      setIsModalVisible(false);
      setTimeout(() => {
        setModalText('');
        setModalState('');
      }, 400);
    } else if (modalState === 'success') {
      setIsModalVisible(false);
      navigate('/operations/view');
    }
  };

  const onCreateOperation = async () => {
    if (!selectedType) return;

    const data = await sendRequest({
      request: Api.callOperation,
      payload: {
        type: selectedType,
        meta: {},
      },
      warnErrorText: 'while creating operation',
      setLoading,
    });

    setIsModalVisible(true);
    if (data?.status !== 'ok') {
      const errorText = data?.message || 'Не удалось установить соединение с сервером.';
      setModalText(`Возникла ошибка:\n\n${errorText}`);
      setModalState('error');
    } else {
      setModalText('Операция успешно создана!');
      setModalState('success');
    }
  };

  return (
    <div className="new_operation">
      <PageTitle
        text="Новая операция"
        RightComponent={(
          <div style={{ display: 'flex', gap: '24px' }}>
            <IconButton
              svgPath={CancelEditingIcon}
              tooltipText="Отменить"
              onClick={onCancelClick}
            />
          </div>
        )}
      />
      <div className="new_operation_container">
        <div style={{
          display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '400px',
        }}
        >
          <SelectButton
            label="Тип операции"
            value={selectedType ? OPERATION_TYPE_LABELS[selectedType] : ''}
            setTempComponentState={setTempComponentState}
            componentStateToSet={tempComponentStates.operationType}
            isActive={tempComponentState === tempComponentStates.operationType}
          />

          {selectedType && (
            <MyButton
              text="Создать операцию"
              onClick={onCreateOperation}
              loading={loading}
            />
          )}
        </div>
        {tempComponentState === tempComponentStates.operationType && (
          <SelectOperationType
            setValue={setSelectedType}
            setTempComponentState={setTempComponentState}
          />
        )}
      </div>

      <MyModal isOpen={isModalVisible} closeFunction={onCloseModal}>
        <div style={{ padding: '20px' }}>
          <p style={{ whiteSpace: 'pre-wrap', marginBottom: '20px' }}>{modalText}</p>
          <MyButton
            text={modalState === 'error' ? 'Закрыть' : 'ОК'}
            onClick={onCloseModal}
          />
        </div>
      </MyModal>
    </div>
  );
}

export default NewOperation;
